const BASE_URL = import.meta.env.VITE_BASE_URL;

export const loginUrl = `${BASE_URL}/v1/auth/login`;
export const logoutUrl = `${BASE_URL}/v1/auth/logout`;
export const initiateResetUrl = `${BASE_URL}/v1/auth/reset-password`;
export const refreshTokenUrl = `${BASE_URL}/v1/auth/token`;
export const changePasswordUrl = `${BASE_URL}/v1/auth/change-password`;
